export default __webpack_public_path__ + "static/media/blog-service.36e12c60.jpg";